import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UUID } from 'angular2-uuid';
import { PlatformEndpointService } from '../../endpoint/endpoint.service';
import { PlatformCommunicatorAuthService } from '../../platform-communicator/platform-communicator.auth.service';
import { PlatformCommunicatorService } from '../../platform-communicator/platform-communicator-onboarding.service';
import { SSOInformation } from './sso-information.model';
import { AbreCuentasService } from '../../../abre-cuentas/abre-cuentas.service';
import { CryptoVaultService } from '../../../external/crypto-vault/crypto-vault.service';

@Injectable({
  providedIn: 'root',
})
export class SsoService {

  constructor(
    private endpointService: PlatformEndpointService,
    private authService: PlatformCommunicatorAuthService,
    private platformCommunicatorService: PlatformCommunicatorService,
    private abreCuentasService: AbreCuentasService,
  ) { }

  async enableAPIGateway(
    grant_type: string,
    client_id: string,
    client_secret: string,
    userAccount?: string,
    password?: string,
  ): Promise<boolean> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const body = new URLSearchParams();
    body.set('grant_type', grant_type);
    body.set('client_id', client_id);
    body.set('client_secret', client_secret);

    if (userAccount && password) {
      body.set('username', userAccount);
      body.set('password', password);
    }

    const options = {
      url: this.endpointService.URLS.API_GATEWAY_SSO,
      method: 'post',
      headers,
      body: body.toString(),
    };

    return await this.platformCommunicatorService.request(options, false).then(
      response => {
        let ssoInformation: SSOInformation;

        if (response.status !== 200) { return false; }

        if (response.body.access_token === undefined) { return false; }

        ssoInformation = new SSOInformation(response.body.access_token,
          response.body.expires_in,
          response.body.refresh_expires_in,
          response.body.refresh_token,
          response.body.token_type,
          response.body['not-before-policy'],
          response.body.session_state,
          response.body.scope);

        this.authService.saveSSOInformation(ssoInformation);

        return true;
      }, _error => {
      return false;
    },
    );
  }
}
